import { BaseService } from '@myhealth-raccoon/services';
import { AutomedDetails, SiteBaseModel } from './types';

class SiteService extends BaseService {
    constructor() {
        super('v1/site', import.meta.env.VITE_BP_API_URL);
    }
    
    public async GetSiteByUmbracoId(umbracoId: string | number) {
        return this.get<SiteBaseModel>(`umbracoId/${umbracoId}`);
    }
    
    public async GetAutomedDetails(siteId: string | number) {
        return this.get<AutomedDetails>(`${siteId}/automed/details`);
    }
}

export const siteService = new SiteService();
export * from './types';